import { getWebPlaysDbLazy, FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME } from './dbService'

async function getStore(
  this: FunnelViewOpenedSeparatorsDbStore,
  mode: IDBTransactionMode = 'readonly',
): Promise<IDBObjectStore> {
  if (!this.dbPromise) {
    this.dbPromise = getWebPlaysDbLazy()
  }

  const db = await this.dbPromise
  return db
    .transaction(FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME, mode)
    .objectStore(FUNNEL_VIEW_OPENED_SEPARATORS_STORE_NAME)
}

export class FunnelViewOpenedSeparatorsDbStore {
  dbPromise: Promise<IDBDatabase> | null = null

  async get(playbookId: string): Promise<number[] | null> {
    const store = await getStore.call(this, 'readonly')
    const request = store.get(playbookId)

    return new Promise<number[] | null>((resolve, reject) => {
      request.onsuccess = () => resolve(request.result?.openedSeparatorIds)
      request.onerror = () => reject(request.error)
    })
  }

  async save(playbookId: string, openedSeparatorIds: number[]) {
    const store = await getStore.call(this, 'readwrite')

    const record = { playbookId, openedSeparatorIds }

    const request = store.put(record)
    return new Promise<void>((resolve, reject) => {
      request.onsuccess = () => resolve()
      request.onerror = () => reject(request.error)
    })
  }

  async remove(playbookId: string) {
    const store = await getStore.call(this, 'readwrite')
    const request = store.delete(playbookId)

    return new Promise<void>((resolve, reject) => {
      request.onsuccess = () => resolve()
      request.onerror = () => reject(request.error)
    })
  }
}

export const instance = new FunnelViewOpenedSeparatorsDbStore()
